import { render, staticRenderFns } from "./chat-mobile.vue?vue&type=template&id=3a17fe64&scoped=true&"
import script from "./chat-mobile.vue?vue&type=script&lang=js&"
export * from "./chat-mobile.vue?vue&type=script&lang=js&"
import style0 from "./chat-mobile.vue?vue&type=style&index=0&id=3a17fe64&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a17fe64",
  null
  
)

component.options.__file = "chat-mobile.vue"
export default component.exports